<template>
  <nav
    class="md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl bg-abi-lightGray flex flex-wrap items-center relative justify-between md:w-56 z-10 py-4 px-6"
  >
    <div
      class="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto pb-[80px]"
    >
      <!-- Toggler -->
      <button
        class="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
        type="button"
        v-on:click="toggleCollapseShow('bg-white m-2 py-3 px-6')"
      >
        <i class="fas fa-bars"></i>
      </button>
      <!-- Brand -->
      <WebsiteSelector title="Content Manager" :links="websiteLinks" />
      <!-- User -->
      <ul class="md:hidden items-center flex flex-wrap list-none">
        <li class="inline-block relative">
          <user-dropdown />
        </li>
      </ul>
      <!-- Collapse -->
      <div
        class="md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-4 md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded"
        v-bind:class="collapseShow"
      >
        <!-- Collapse header -->
        <div class="md:min-w-full md:hidden block">
          <div class="flex flex-wrap">
            <div class="w-6/12">
              <router-link
                class="md:block text-left md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold tracking-wider p-4 px-0"
                to="/"
              >
                Content Manager
              </router-link>
            </div>
            <div class="w-6/12 flex justify-end">
              <button
                type="button"
                class="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                v-on:click="toggleCollapseShow('hidden')"
              >
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>
        <!-- Form -->
        <form class="mt-6 mb-4 md:hidden">
          <div class="mb-3 pt-0">
            <input
              type="text"
              placeholder="Search"
              class="border-0 px-3 py-2 h-12 border border-solid border-blueGray-500 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-base leading-snug shadow-none outline-none focus:outline-none w-full font-normal"
            />
          </div>
        </form>

        <!-- Divider -->
        <hr class="my-4 md:min-w-full" />
        <!-- Heading -->
        <router-link to="/admin/dashboard">
          <h6
            class="md:min-w-full text-blueGray-500 text-xs uppercase font-bold tracking-wider block pt-1 no-underline"
          >
            Dashboard
          </h6>
        </router-link>

        <!-- Divider -->
        <hr class="my-4 md:min-w-full" />
        <!-- Basic Components -->
        <SideBarDropDown
          title="Basic Components"
          :options="basicComponentList.filter((item) => item.be_used === '1')"
        />
        <!-- Special Components -->
        <SideBarDropDown
          title="Special Components"
          :options="specialComponentList"
        />
        <!-- Page List -->
        <SideBarDropDown title="Pages" :options="PageList" />
        <!-- Page List -->
        <SideBarDropDown title="Notice" :options="NoticeList" />
      </div>
    </div>
  </nav>
  <HardRefreshBtn />
</template>

<script>
import { mapGetters } from "vuex";
import * as Constants from "@/store/constants";
import WebsiteSelector from "@/components/Shared/Input/WebsiteSelector.vue";
import HardRefreshBtn from "@/components/Shared/Sidebar/HardRefreshBtn.vue";
import SideBarDropDown from "@/components/Shared/Dropdowns/SideBarDropDown";
import UserDropdown from "@/components/Shared/Dropdowns/UserDropdown.vue";

export default {
  components: {
    WebsiteSelector,
    UserDropdown,
    SideBarDropDown,
    HardRefreshBtn
  },
  data() {
    return {
      websiteLinks: [
        {
          title: "Product Manager",
          icon: "<i class='fas fa-bath fa-fw'></i>",
          link: "//product-manager-v2.web.app"
        },
        {
          title: "Trade Manager",
          icon: "<i class='fas fa-address-book fa-fw'></i>",
          link: "//trade-manager-v2.web.app"
        },
        {
          title: "Logistics Manager",
          icon: "<i class='fas fa-truck fa-fw'></i>",
          link: "//logistic-manager-d5635.web.app"
        }
      ],
      collapseShow: "hidden"
    };
  },
  computed: {
    basicComponentList() {
      return this.getAllComponent
        .filter((item) => {
          return (
            !Constants.SPECIAL_COMPONENTS.map((item) => item.name).includes(
              item.name
            ) && item.name !== "abi_category"
          );
        })
        .map((item) => {
          return {
            id: item.id,
            name: item.display_name,
            icon: "fas fa-cube",
            be_used: item.be_used
          };
        });
    },
    specialComponentList() {
      return this.getAllComponent
        .filter((item) => {
          return Constants.SPECIAL_COMPONENTS.map((item) => item.name).includes(
            item.name
          );
        })
        .map((item) => {
          return {
            id: item.id,
            name: item.display_name,
            icon: "fas fa-cube",
            be_used: item.be_used
          };
        });
    },
    PageList() {
      return Constants.PAGES;
    },
    NoticeList() {
      return Constants.NOTICE;
    },
    ...mapGetters(["getAllComponent", "getRegion"])
  },
  methods: {
    toggleCollapseShow(classes) {
      this.collapseShow = classes;
    }
  }
};
</script>
